export const OCCUPATIONS = [
  'Administrador',
  'Administrador público',
  'Advogado',
  'Agricultor',
  'Agrônomo',
  'Agropecuarista',
  'Analista e desenvolvedor de sistemas',
  'Animador',
  'Arqueólogo',
  'Arquiteto',
  'Arquivologista',
  'Artista plástico',
  'Astrônomo',
  'Ator',
  'Biblioteconomista',
  'Biomédico',
  'Bioquímico',
  'Biotecnólogo',
  'Chef',
  'Cientista da computação',
  'Construtor civil',
  'Construtor naval',
  'Contabilista',
  'Cooperativista',
  'Dançarino',
  'Dentista',
  'Designer',
  'Designer de games',
  'Designer de interiores',
  'Designer de moda',
  'Ecologista',
  'Economista',
  'Educador físico',
  'Educomunicador',
  'Empresário',
  'Enfermeiro',
  'Engenheiro acústico',
  'Engenheiro aeronáutico',
  'Engenheiro agrícola',
  'Engenheiro ambiental e sanitário',
  'Engenheiro biomédico',
  'Engenheiro civil',
  'Engenheiro da computação',
  'Engenheiro de alimentos',
  'Engenheiro de biossistemas',
  'Engenheiro de controle e automação',
  'Engenheiro de energia',
  'Engenheiro de inovação',
  'Engenheiro de materiais',
  'Engenheiro de minas',
  'Engenheiro de pesca',
  'Engenheiro de petróleo',
  'Engenheiro de produção',
  'Engenheiro de segurança do trabalho',
  'Engenheiro de sistemas',
  'Engenheiro de software',
  'Engenheiro de telecomunicações',
  'Engenheiro de transporte e mobilidade',
  'Engenheiro elétrico',
  'Engenheiro eletrônico',
  'Engenheiro físico',
  'Engenheiro florestal',
  'Engenheiro hídrico',
  'Engenheiro mecânico',
  'Engenheiro mecatrônico',
  'Engenheiro naval',
  'Engenheiro químico',
  'Especialista em comércio exterior',
  'Estatístico',
  'Esteticista',
  'Farmacêutico',
  'Filósofo',
  'Físico',
  'Fisioterapeuta',
  'Fonoaudiólogo',
  'Fotógrafo',
  'Geofísico',
  'Geógrafo',
  'Geólogo',
  'Gerente comercial',
  'Gerontólogo',
  'Gestor ambiental',
  'Gestor da qualidade',
  'Gestor da tecnologia da informação',
  'Gestor de recursos humanos',
  'Gestor de turismo',
  'Gestor em saúde',
  'Gestor hospitalar',
  'Gestor público',
  'Historiador',
  'Historiador da arte',
  'Hoteleiro',
  'Jornalista',
  'Linguista',
  'Matemático',
  'Médico',
  'Meteorologista',
  'Minerador',
  'Museologista',
  'Músico',
  'Musicoterapeuta',
  'Nanotecnólogo',
  'Nutricionista',
  'Oceanógrafo',
  'Pedagogo',
  'Piloto de avião',
  'Produtor audiovisual',
  'Produtor cênico',
  'Produtor cultural',
  'Produtor editorial',
  'Produtor fonográfico',
  'Produtor multimídia',
  'Produtor publicitário',
  'Professor',
  'Psicólogo',
  'Psicopedagogo',
  'Publicitário',
  'Químico',
  'Radialista',
  'Radiologista',
  'Relações internacionais',
  'Relações públicas',
  'Secretária',
  'Secretária executiva',
  'Silvicultor',
  'Sociólogo',
  'Teólogo',
  'Terapeuta ocupacional',
  'Tradutor e intérprete',
  'Turismólogo',
  'Veterinário',
  'Zootecnólogo',
  'Outra'
]
